<template>
  <v-row class="asc-plot-overlays-wrapper--container" no-gutters>
    <v-col cols="2">
      <asc-switch v-model="separateCharts" label="Separate Charts"></asc-switch>
    </v-col>
    <v-col cols="10">
      <div class="asc-display-flex">
        <v-divider class="asc-plot-overlays-wrapper--divider" vertical />
        <asc-plot-overlay-list
          :items="items"
          :on-update="onUpdate"
        ></asc-plot-overlay-list>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import AscSwitch from '@/components/atoms/AscSwitch'
import AscPlotOverlayList from '@/components/molecules/AscPlotOverlayList'

export default {
  name: 'AscPlotOverlaysTabWrapper',

  components: {
    AscSwitch,
    AscPlotOverlayList,
  },

  props: {
    pagePlot: {
      type: Object,
      default: () => {},
    },
    items: {
      type: Array,
      default: () => [],
    },
    onUpdate: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      separateCharts: this.pagePlot?.options?.separateCharts || false,
    }
  },

  watch: {
    separateCharts(newValue) {
      this.separateCharts = newValue
      this.$emit('separateChartsSelection', newValue)
    },
  },
}
</script>

<style lang="scss">
.asc-plot-overlays-wrapper {
  &--container {
    height: 90px;
    background-color: transparent;
  }

  &--divider {
    color: $gray-300;
    margin: 0 30px;
    min-height: 90px;
  }

  .asc-display-flex {
    display: flex;
  }
}
</style>
